import { DeepLinkService } from '@/common/api/api.service'
import { get } from 'lodash'
import router from '@/router'
import {
  PATH_NAME_INSTANTPLAY_LIST,
  PATH_NAME_LIST,
  PATH_NAME_SUPERMULTISECTION,
  PATH_NAME_SUPERMULTISECTION_WITH_API, PATH_NAME_THEME_MOVIE, PATH_NAME_THEME_VOD
} from '@/common/router.const'
function commonListBeforeEnter (to, from, next) {
  const apiQueryParam = get(to, 'query.api', '')
  if (apiQueryParam === '') {
    const uiCode = get(to, 'path', '').split('/').pop()
    if (uiCode === undefined || uiCode === '') { next() }
    DeepLinkService.getUrlFromUiCode(uiCode).then((data) => {
      const orgPath = get(to, 'path', '')
      const apiUrl = get(data, 'url', '')
      const came = get(data, 'query.came', '')
      next({ path: `${orgPath}?api=${encodeURIComponent(apiUrl)}${came === '' ? '&came=home' : ''}`, replace: true })
    })
  } else {
    next()
  }
}
export default [
  {
    path: '/list/:uiCode',
    name: PATH_NAME_LIST,
    components: {
      list: () => import(/* webpackChunkName: "viewMore" */'@/views/viewmore/List')
    },
    props: true,
    beforeEnter: commonListBeforeEnter
  },
  {
    path: '/instantlist/:uiCode',
    name: PATH_NAME_INSTANTPLAY_LIST,
    components: {
      list: () => import(/* webpackChunkName: "viewMore" */'@/views/viewmore/InstantPlayList')
    },
    props: true,
    beforeEnter: commonListBeforeEnter
  },
  {
    path: '/supermultisection/:uiCode',
    name: PATH_NAME_SUPERMULTISECTION,
    components: {
      sumermultisection_with_gnb_code: () => import(/* webpackChunkName: "supermultisectionWithGnbCode" */'@/views/supermultisection/SuperMultiSectionWithGnbCode.vue')
    },
    props: true
  },
  {
    path: '/supermultisection',
    name: PATH_NAME_SUPERMULTISECTION_WITH_API,
    components: {
      sumermultisection_with_api: () => import(/* webpackChunkName: "superMultisectionWithApi" */'@/views/supermultisection/SuperMultiSectionWithApi.vue')
    },
    props: true
  },
  { // TODO: 오픈뒤에 URL 정리 해야 함 지금 은 실서버데이터를 바꾸면 기존 서비스에서 에러가 날 수 있으나 임시로 처리
    path: '/movie/theme-contents',
    alias: '/movie/theme-contents.html',
    name: PATH_NAME_THEME_MOVIE,
    beforeEnter (to, from, next) {
      next('/list/EN' + to.query.themeid)
    }
  },
  {
    path: '/vod/theme-contents',
    alias: '/vod/theme-contents.html',
    name: PATH_NAME_THEME_VOD,
    beforeEnter (to, from, next) {
      next('/list/EN' + to.query.themeid)
    }
  }
]
